module.exports = __webpack_public_path__ + "static/media/Arcade_5841.ff0e1f49.jpg";